import React, { useCallback, useState } from "react";
import AcuityRightDrawer from "../../../../../Components/TemporarySidebar";
import IconButton from "@material-ui/core/IconButton";
import BackIcon from "@material-ui/icons/KeyboardBackspace";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import makeStyles from "@material-ui/core/styles/makeStyles";
import StandardExecutiveCoaching from '../Assignment/StandardExecutiveCoaching';
import CoachingProgramDimension from '../Assignment/CoachingProgramDimension';
import CoachingCommercialsBilling from '../Assignment/CoachingCommercialsBilling';
import ProgramFlowSetup from '../Assignment/ProgramFlowSetup'
import ProgramDocumentation from '../Assignment/ProgramDocumentation'
import TermsPolicies from '../Assignment/TermsPolicies';
import EditIcon from "@material-ui/icons/Edit";
import AssignmentHeaderModal from '../Assignment/AssignmentHeaderModal';
import AssignmentIcon from '../../../../../Images/AssignmentIcon.png';

const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'sticky',
        top: '0',
        marginTop: '-24px',
        borderTop: '30px solid #fff',
        backgroundColor: "#fff",
        color: '#232323',
        boxShadow: "0px 3px 5px #0000001A",
        '& > div': {
            display: 'flex',
            justifyContent: 'space-between',
            '& span': {
                color: '#757575',
            },
            '& > div': {
                display: 'flex',
                alignItems: "center",

            }
        }
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
    wrapper: {
        margin: '3%'
    },
    detail: {
        padding: '3%',
        backgroundColor: "#fff",
        boxShadow: "0px 3px 6px #232323",
    },
    paper: {
        // padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    bottomBar: {
        boxShadow: '0px 0px 6px #232323',
        padding: '15px',
        textAlign: 'center',
        margin: '0 -24px',
        marginTop: '10px',
        position: 'sticky',
        bottom: '0',
        zIndex: 1075,
        backgroundColor: '#fff'
    },
    drawerBorder: {
        background: '#40C9FC',
        left: '0',
        height: '10px',
        width: '100%',
        position: 'fixed',
        top: '64px',
        cursor: 'pointer',
        zIndex: 1111
    }
}));

const stepList = [
    {
        title: 'Standard executive coaching'
    },
    {
        title: 'Coaching program dimensions'
    },
    {
        title: 'Coaching commercials & billing'
    },
    {
        title: 'Programme flow setup'
    },
    {
        title: 'Program documentation'
    },
    {
        title: 'Terms and Policies'
    },

]
const AssignmentDrawer = (props) => {
    const {
        handleClose,
        stepperData,
        headerType,
        headerModal,
        setHeaderModal,
        currentSelection
    } = props;
    const classes = useStyles();
    const [activeStepId, setActiveStepId] = useState(1);
    const activeStepIdArray = [2, 3, 5, 6];

    const handleDrawerClose = () => {
        if (activeStepId !== 1) {
            setActiveStepId((prevState) => prevState - 1);
        } else {
            handleClose();
        }
    }

    const onNextClick = () => {
        window.document.getElementsByClassName("MuiDrawer-paperAnchorRight")[0].scrollTop = 0;
        setActiveStepId((prevState) => prevState + 1);
    }

    const loadStep = useCallback((props, stepId) => {
        switch (stepId) {
            case 1:
                return <StandardExecutiveCoaching{...props}
                    onNextClick={onNextClick} />
            case 2:
                return <CoachingProgramDimension {...props}
                    onNextClick={onNextClick} />
            case 3:
                return <CoachingCommercialsBilling {...props}
                    onNextClick={onNextClick} />
            case 4:
                return <ProgramFlowSetup {...props}
                    onNextClick={onNextClick} />
            case 5:
                return <ProgramDocumentation {...props}
                    onNextClick={onNextClick} />
            case 6:
                return <TermsPolicies {...props}
                    onNextClick={onNextClick} />
        }
    }, [activeStepId])

    const handleOpenModal = () => {
        if (headerType == "programme_info" || headerType == "commercials_and_billing") {
            setHeaderModal("headerModal");
        } else {
            setHeaderModal("");
        }
    }

    const [anchorElColorSchemes, setAnchorElColorSchemes] = useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorElColorSchemes(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorElColorSchemes(null);
    };

    const open = Boolean(anchorElColorSchemes);

    const colorSchemesProps = {
        open: open,
        handleOpen: handlePopoverOpen,
        handleClose: handlePopoverClose,
        anchorEl: anchorElColorSchemes,
        drawerBorder: classes.drawerBorder,
        currentSelection: props.location?.state?.currentAssignment || currentSelection,
        module: "assignment",
        ImgUrl: AssignmentIcon
    }

    return (
        <>
            <AcuityRightDrawer colorSchemesProps={colorSchemesProps}>
                <AppBar position="static" className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <div>
                            <IconButton onClick={handleDrawerClose} edge="start" className={classes.backButton}
                                color="inherit"
                                aria-label="back">
                                <BackIcon />
                            </IconButton>
                            <h1>
                                {stepperData}
                                {/*{stepList[activeStepId - 1].title}*/}
                            </h1>
                        </div>
                        {activeStepIdArray.includes(activeStepId) ? <></> :
                            <IconButton onClick={handleOpenModal} color="inherit">
                                <EditIcon />
                            </IconButton>}
                    </Toolbar>
                </AppBar>
                {loadStep(props, activeStepId)}
            </AcuityRightDrawer>

            {headerModal && <AssignmentHeaderModal
                {...props}
                isOpen={headerModal}
                onClose={() => {
                    setHeaderModal('')
                }}
            />}

        </>
    )
}

export default AssignmentDrawer;
